import { useEffect, useState } from 'react';
import { api } from '../lib/api';

const cache = new Map<string, HTMLImageElement>();

/** Lädt (und cached) ein Bild als HTMLImageElement für die Konva-Darstellung. */
export function useImageElement(imageId?: string): HTMLImageElement | undefined {
  const [element, setElement] = useState<HTMLImageElement | undefined>(
    imageId ? cache.get(imageId) : undefined,
  );

  useEffect(() => {
    if (!imageId) {
      setElement(undefined);
      return;
    }
    const cached = cache.get(imageId);
    if (cached) {
      setElement(cached);
      return;
    }
    const img = new Image();
    img.src = api.imageRawUrl(imageId);
    img.onload = () => {
      cache.set(imageId, img);
      setElement(img);
    };
    img.onerror = () => setElement(undefined);
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageId]);

  return element;
}
